export const rules = {
  profession: { required: true, message: '必填项', trigger: 'blur' },
  business: { required: true, message: '必填项', trigger: 'blur' },
  store: { required: true, message: '必填项', trigger: 'blur' },
  pay_time: { required: true, message: '必填项', trigger: 'blur' },
  filename: { required: true, message: '必填项', trigger: 'blur' },
}


// WEBPACK FOOTER //
// ./src/views/statistics/buy-again/data.js